import React from 'react';

import Main from '../components/general/Main';
import Wrapper from '../components/general/Wrapper/Wrapper';
import PilgrimTopMenu from '../components/PilgrimTopMenu';

const Help = () => (
  <div>
    <PilgrimTopMenu />
    <Main>
      <Wrapper>{'Help page'}</Wrapper>
    </Main>
  </div>
);

export default Help;
